module.exports = __webpack_public_path__ + "img/login_bg.da4ffdb5.jpg";